

























































































































































































































































































import {
  defineNuxtComponent,
  computed,
  ref,
  nextTick
} from '~/utils/nuxt3-migration'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { ciRefresh } from '~/icons/source/regular/refresh'
import { ciRefresh as ciRefreshSolid } from '~/icons/source/solid/refresh'
import { useI18n } from '~/compositions/i18n'
import { formatNumber } from '~/utils/number'
import { ciParking } from '~/icons/source/regular/parking'
import { ciListView } from '~/icons/source/regular/list-view'
import { ciEye as ciEyeRegular } from '~/icons/source/regular/eye'
import { defineComponentTranslations } from '~/utils/i18n'
import { useAnalytics } from '~/compositions/analytics'
import { useDeps } from '~/compositions/dependency-container'
import ClassifiedService from '~/services/classified/ClassifiedService'
import useClassifiedAction from '~/compositions/useClassifiedAction'
import { useSnackbar } from '~/compositions/snackbar'
import { ciRefreshInTime } from '~/icons/source/solid/refresh-in-time'
import { ciRefreshInTime as ciRefreshInTimeRegular } from '~/icons/source/regular/refresh-in-time'
import { ciExchange } from '~/icons/source/solid/exchange'
import CAutoTouchModal from '~/components/shared/configurable/CAutoTouchModal.vue'
import { ciCopy } from '~/icons/source/solid/copy'
import { ciPrinter } from '~/icons/source/solid/printer'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { CategoryId } from '~/models/category/types'
import { ciEdit } from '~/icons/source/regular/edit'
import { ciEye } from '~/icons/source/solid/eye'
import { ciEyeSlash } from '~/icons/source/solid/eye-slash'
import { ciTrash } from '~/icons/source/solid/trash'
import { ciPartsAccessories } from '~/icons/source/solid/parts-accessories'
import { USER_NS } from '~/store/modules/shared/user/state'
import HideFromPublicModal from '~/components/car/classifieds/HideFromPublicModal.vue'
import ClassifiedDeleteModal from '~/components/car/classifieds/ClassifiedDeleteModal.vue'
import { AutoTouchSchedule } from '~/models/auto-touch/types'
import { SET_AUTO_TOUCH_DATA_IN_VIEW } from '~/store/modules/shared/classifieds/view/mutation-types'
import ClassifiedViewActionsBlacklistButton from '~/components/car/classifieds/view/ClassifiedViewActionsBlacklistButton.vue'
import { AccessToggleName } from '~/models/user/access-toggles'
import { useAppConfirmationModal } from '~/compositions/app-confirmation-modal'
import ClassifiedModifiedAgoBadge from '~/components/car/classifieds/badges/ClassifiedModifiedAgoBadge.vue'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import {
  MODIFY_ROW_TOUCHED,
  SET_AUTO_TOUCH_DATA_IN_SEARCH
} from '~/store/modules/shared/classifieds/search/mutation-types'
import { useUserAgent } from '~/compositions/user-agent'
import { HttpStatus } from '~/constants/http'
import NotEnoughCreditsDropdown from '~/components/car/NotEnoughCreditsDropdown.vue'

export default defineNuxtComponent({
  components: {
    NotEnoughCreditsDropdown,
    ClassifiedModifiedAgoBadge,
    ClassifiedViewActionsBlacklistButton,
    ClassifiedDeleteModal,
    HideFromPublicModal,
    CAutoTouchModal,
    CCard,
    CBadge
  },
  setup() {
    const [classifiedService, legacyUrlService] = useDeps(
      ClassifiedService,
      LegacyUrlService
    )
    const {
      state: classifiedViewState,
      getters: classifiedViewGetters,
      dispatch: classifiedViewDispatch,
      commit: classifiedViewCommit
    } = useNamespacedStore<ClassifiedViewState>(CLASSIFIED_VIEW_NS)
    const { commit: classifiedSearchCommit } = useNamespacedStore(
      CLASSIFIED_SEARCH_NS
    )
    const { getters: userGetters } = useNamespacedStore(USER_NS)
    const analytics = useAnalytics()
    const snackbar = useSnackbar()
    const { t } = useI18n()
    const { handleActionError } = useClassifiedAction()
    const confirm = useAppConfirmationModal()
    const { isMobile } = useUserAgent()

    const isActionLoading = ref(false)
    const isAutoTouchModalVisible = ref(false)
    const isPrintModalVisible = ref(false)
    const isVisibilityButtonHovered = ref(false)
    const isHideFromPublicModalVisible = ref(false)
    const isDeleteModalVisible = ref(false)
    const isNotEnoughCreditsForTouchDropdownVisible = ref(false)

    const stats = computed(() => classifiedViewState.stats)

    const classifiedId = computed(() => classifiedViewState.classifiedId)

    const classified = computed(() => classifiedViewState.classified)

    const classifiedIsNonPublic = computed(() =>
      classifiedViewGetters('isNonPublic')
    )

    const isPlotClassified = computed(() =>
      classifiedViewGetters('isPlotClassified')
    )

    const sellerIsManager = computed(() =>
      classifiedViewGetters('sellerIsManager')
    )

    const sellerIsDealer = computed(() =>
      classifiedViewGetters('sellerIsDealer')
    )

    const sellerIsAgent = computed(() => classifiedViewGetters('sellerIsAgent'))

    const sellerIsNonPublicDealer = computed(() =>
      classifiedViewGetters('sellerIsNonPublicDealer')
    )

    const classifiedIsWanted = computed(() => classifiedViewGetters('isWanted'))

    const isVehicleClassified = computed(() =>
      classifiedViewGetters('isVehicleClassified')
    )

    const userIsAdmin = computed(() => userGetters('isAdmin'))

    const userIsSingle = computed(() => userGetters('isSingle'))

    const statisticsUrl = computed(
      () =>
        classified.value.stats_url ||
        `/classifieds/${classifiedId.value}/edit/statistics/`
    )

    const classifiedIsTradable = computed(
      () => classified.value.trades?.categories?.length > 0
    )

    const copyUrl = computed(() =>
      legacyUrlService.getCompatibilityCopyUrl(
        classified.value.category_ids,
        classifiedId.value
      )
    )

    const shouldShowSalesSignButton = computed(() => {
      const salesSignCompatibleCategories = [
        CategoryId.CARS,
        CategoryId.BIKES,
        CategoryId.VANS,
        CategoryId.TRUCKS,
        CategoryId.BUSES,
        CategoryId.BUILDERS,
        CategoryId.SEMITRUCKS,
        CategoryId.SEMITRAILERS,
        CategoryId.TRACTORS,
        CategoryId.FORKLIFTS,
        CategoryId.TAXIS,
        CategoryId.HOBBY,
        CategoryId.MOTORHOMES,
        CategoryId.CARAVANS
      ]

      return (
        !classifiedIsWanted.value &&
        salesSignCompatibleCategories.some(categoryId =>
          classified.value.category_ids.includes(categoryId as number)
        )
      )
    })

    const shouldShowCopyButton = computed(
      () => !userIsAdmin.value && !userIsSingle.value
    )

    const visibilityButtonState = computed(() => {
      const visibleState = {
        variant: 'success',
        icon: ciEye,
        tooltip: t('show classified')
      }

      const hiddenState = {
        variant: 'warning',
        icon: ciEyeSlash,
        tooltip: t('hide classified')
      }

      if (classified.value.states.is_hidden) {
        return isVisibilityButtonHovered.value ? visibleState : hiddenState
      } else {
        return isVisibilityButtonHovered.value ? hiddenState : visibleState
      }
    })

    const adminVisibilityButtonState = computed(() => {
      const visibleState = {
        variant: 'success',
        icon: ciEye,
        tooltip: 'Δείξε στο κοινό'
      }

      const hiddenState = {
        variant: 'warning',
        icon: ciEyeSlash,
        tooltip: 'Κρύψε από κοινό'
      }

      if (classified.value.states.is_non_public) {
        return isVisibilityButtonHovered.value ? visibleState : hiddenState
      } else {
        return isVisibilityButtonHovered.value ? hiddenState : visibleState
      }
    })

    const isBlacklistButtonVisible = computed(
      () =>
        userGetters('userHasAccessTo')(AccessToggleName.ADMIN_BLACKLIST) &&
        !sellerIsManager.value &&
        !sellerIsDealer.value &&
        !sellerIsAgent.value &&
        !sellerIsNonPublicDealer.value
    )

    const editUrlTo = computed(() =>
      isPlotClassified.value
        ? undefined
        : `/classifieds/${classifiedId.value}/edit/`
    )

    const editUrlHref = computed(() =>
      isPlotClassified.value
        ? `https://www.plot.gr/classifieds/${classifiedId.value}/edit/details/`
        : undefined
    )

    function onStatisticsClick() {
      analytics.recordEvent({
        namespace: 'n_classified_view_actions',
        action: 'click',
        label: 'statistics'
      })
    }

    async function onTouchButtonClick() {
      analytics.recordEvent({
        namespace: 'n_classified_view_actions',
        action: 'click',
        label: 'touch'
      })

      isActionLoading.value = true

      try {
        const response = await classifiedService.touch(classifiedId.value)

        classifiedSearchCommit(MODIFY_ROW_TOUCHED, {
          classifiedId: classifiedId.value,
          modified: response.data.classified.modified
        })

        await classifiedViewDispatch('reloadClassifiedView')

        snackbar.success(response.message)
      } catch (err) {
        if (err.response?.status === HttpStatus.NO_CREDITS) {
          isNotEnoughCreditsForTouchDropdownVisible.value = true
          return
        }

        handleActionError(err)
      } finally {
        isActionLoading.value = false
      }
    }

    function onAutoTouchButtonClick() {
      analytics.recordEvent({
        namespace: 'n_classified_view_actions',
        action: 'click',
        label: 'autotouch'
      })

      isAutoTouchModalVisible.value = true
    }

    function onEditButtonClick() {
      analytics.recordEvent({
        namespace: 'n_classified_view_actions',
        action: 'click',
        label: 'edit'
      })
    }

    function onPrintButtonClick() {
      if (isVehicleClassified.value) {
        isPrintModalVisible.value = true
      } else {
        window.print()
      }
    }

    async function onPrintClassifiedButtonClick() {
      isPrintModalVisible.value = false
      await nextTick()

      window.print()
    }

    function onVisibilityButtonClick() {
      analytics.recordEvent({
        namespace: 'n_classified_edit_actions',
        action: 'click',
        label: 'visibility'
      })

      if (classified.value.states.is_hidden) {
        showClassified()
      } else {
        confirm.show({
          title: t('hide classified'),
          variant: 'warning',
          confirmButtonText: t('hide'),
          text: t('are you sure you want to hide this classified?'),
          onConfirm: hideClassified
        })
      }
    }

    async function showClassified() {
      isActionLoading.value = true

      try {
        const data = await classifiedService.show(classifiedId.value)

        snackbar.success(data.message)
        await classifiedViewDispatch('reloadClassifiedView')
      } catch (err) {
        handleActionError(err)
      } finally {
        isActionLoading.value = false
      }
    }

    async function hideClassified() {
      isActionLoading.value = true

      try {
        const data = await classifiedService.hide(classifiedId.value)

        snackbar.success(data.message)
        await classifiedViewDispatch('reloadClassifiedView')
      } catch (err) {
        handleActionError(err)
      } finally {
        isActionLoading.value = false
      }
    }

    async function onAdminVisibilityButtonClick() {
      if (!classified.value.states.is_non_public) {
        isHideFromPublicModalVisible.value = true
        return
      }

      isActionLoading.value = true

      try {
        const data = await classifiedService.showToPublic(classifiedId.value)
        snackbar.success(data.message)
        await classifiedViewDispatch('reloadClassifiedView')
      } catch (err) {
        handleActionError(err)
      } finally {
        isActionLoading.value = false
      }
    }

    function onDeleteButtonClick() {
      if (!userIsAdmin.value) {
        analytics.recordEvent({
          namespace: 'n_classified_view_actions',
          action: 'click',
          label: 'delete'
        })
      }

      isDeleteModalVisible.value = true
    }

    async function hideClassifiedFromPublic({
      reason,
      notes
    }: {
      reason: string
      notes: string
    }) {
      isActionLoading.value = true

      try {
        const data = await classifiedService.hideFromPublic(
          classifiedId.value,
          reason,
          notes
        )
        await classifiedViewDispatch('reloadClassifiedView')
        snackbar.success(data.message)
      } catch (err) {
        handleActionError(err)
      } finally {
        isActionLoading.value = false
      }
    }

    async function deleteClassified({ reason }: { reason?: string } = {}) {
      isActionLoading.value = true

      try {
        const data = await classifiedService.delete(classifiedId.value, reason)

        await classifiedViewDispatch('reloadClassifiedView')

        snackbar.success(data.message)
      } catch (err) {
        handleActionError(err)
      } finally {
        isActionLoading.value = false
      }
    }

    function onAutoTouchDataChange({
      data
    }: {
      data: Partial<AutoTouchSchedule> | null
    }) {
      classifiedViewCommit(SET_AUTO_TOUCH_DATA_IN_VIEW, data)
      classifiedSearchCommit(SET_AUTO_TOUCH_DATA_IN_SEARCH, {
        classifiedId: classifiedId.value,
        autoTouchData: data
      })
    }

    function onConvertToPartButtonClick() {
      confirm.show({
        title: 'Μετατροπή σε ανταλλακτικό',
        text:
          'Εαν συνεχίσεις η αγγελία θα καταστραφεί (δεν μπορούμε να την επαναφέρουμε αυτόματα) και θα μετατραπεί σε ανταλλακτικό. Θέλεις σίγουρα να συνεχίσεις;',
        variant: 'danger',
        confirmButtonText: 'Συνέχεια',
        cancelButtonText: 'Άκυρο',
        onConfirm: () => {
          window.location.href = `/classifieds/${classifiedId.value}/legacy-make-part/`
        }
      })
    }

    function onVisibilityButtonMouseLeave() {
      if (isMobile.value) {
        return
      }

      isVisibilityButtonHovered.value = false
    }

    function onVisibilityButtonMouseEnter() {
      if (isMobile.value) {
        return
      }

      isVisibilityButtonHovered.value = true
    }

    return {
      ciParking,
      ciListView,
      ciRefresh,
      ciRefreshSolid,
      ciEyeRegular,
      ciRefreshInTime,
      ciExchange,
      ciCopy,
      ciPrinter,
      ciEdit,
      ciTrash,
      ciPartsAccessories,
      ciRefreshInTimeRegular,
      copyUrl,
      classifiedId,
      isActionLoading,
      isAutoTouchModalVisible,
      isPrintModalVisible,
      isDeleteModalVisible,
      isVehicleClassified,
      stats,
      classifiedIsNonPublic,
      classifiedIsTradable,
      statisticsUrl,
      shouldShowSalesSignButton,
      shouldShowCopyButton,
      visibilityButtonState,
      adminVisibilityButtonState,
      userIsAdmin,
      isVisibilityButtonHovered,
      isHideFromPublicModalVisible,
      classified,
      isBlacklistButtonVisible,
      isNotEnoughCreditsForTouchDropdownVisible,
      editUrlTo,
      editUrlHref,
      formatNumber,
      onStatisticsClick,
      onTouchButtonClick,
      onAutoTouchButtonClick,
      onPrintButtonClick,
      onPrintClassifiedButtonClick,
      onEditButtonClick,
      onVisibilityButtonClick,
      onAdminVisibilityButtonClick,
      onDeleteButtonClick,
      onAutoTouchDataChange,
      onConvertToPartButtonClick,
      hideClassifiedFromPublic,
      deleteClassified,
      onVisibilityButtonMouseLeave,
      onVisibilityButtonMouseEnter
    }
  },
  i18n: defineComponentTranslations({
    view_statistics: {
      en: 'View statistics',
      el: 'Προβολή στατιστικών'
    },
    print_classified: {
      en: 'Print classified',
      el: 'Εκτύπωση αγγελίας'
    }
  })
})
